import React from 'react';
import { Field, reduxForm} from 'redux-form';
import { FileUpload  } from '../../../../itrust_common/components/form';
import { UPLOAD_RULES } from '../../../../itrust_common/components/Constants';

let UploadForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-body my-n7">
        <div className="row">
          <div className="col form-group error">
            {/* <label className="w-100"> */}
              <Field type='file' name="document_attributes" component={FileUpload} wrapperClasses="" imageClasses="py-3 px-5 w-100" accept={UPLOAD_RULES.document.accept}/>
            {/* </label> */}
          </div>
        </div>
      </div>
    </form>
  );
}

UploadForm = reduxForm({
  form: 'uploadForm',
})(UploadForm)

export default UploadForm;